export default __webpack_public_path__ + "static/media/verkoop-wafel.c1d46097.jpeg";